export default __webpack_public_path__ + "static/media/norbert-levajsics-dUx0gwLbhzs-unsplash.36734f5e.jpg";